import React from 'react'

import { updateCharacter } from '../api/character'
import { addEvent } from '../api/events'
import { updateDestinyPool } from '../api/rolling'
import LoadingButton from './LoadingButton'

const NewSessionButton = ({ campaignId, characterName, characters }) => {
  const onClick = async () => {
    const result = window.confirm('Starting a new session clears the destiny pool and character\'s wound/strain handicaps. Press OK to confirm.')
    if (!result) return false

    try {
      await updateDestinyPool(campaignId, characterName, 'clear')

      const characterKeys = Object.keys(characters)
      await Promise.all(characterKeys.map(async (id) => {
        return await updateCharacter(campaignId, id, {
          condition: {
            strainHandicap: 0,
            woundHandicap: 0
          }
        })
      }))

      await addEvent(campaignId, characterName, { text: 'Reset characters\' strain/wound handicaps' })
    } catch(e) {
      console.error(e)
    }
  }

  return (
    <LoadingButton onClick={onClick} textOnly>
      New Session
    </LoadingButton>
  )
}

export default NewSessionButton
